<template>
  <TableTemplate
    v-model="tableResult"
    :columns="tableColumns"
    :columnVariables="tableColumnVariables"
    :skeletonClass="skeletonClass"
    :selected="selected"
    :enable-sorting="true"
    :remove-checkboxes="true"
    :page="page"
    :max="max"
    :on-row-click="selectRow"
    @update-column-order="updateColumnOrder"
    @set-page="(v) => (page = v)"
    id="advice-orders"
    ref="table"
  >
    <template #above>
      <!-- <pre>
        {{ tableResult }}
      </pre> -->
      <TableHeader
        title="Order advies"
        :show-button="showButton"
        :alwaysShowMultiSelectCheckbox="true"
        :refetch="refetch"
        :exportParams="exportEndpointParams"
        export-endpoint="/drop/export/csv"
        csv-name="advice-orders"
        export-endpoint-type="post"

        @customize-layout="customizeLayout"
      >

        <template #header-buttons-after="props">
        </template>
      </TableHeader>

      <div class="row bg-white my-3 order-font-size-normal py-1">
        <div class="col">
          <p class="text-center my-1 font-weight-bold text-order-normal">
            Totale Voorraadwaarde
          </p>
          <p class="text-center my-1 font-weight-bold order-font-size-normal">€ {{filteredResult.reduce((a, b) => a + b.currentStock * b.price,0).toFixed(0)}}</p>
        </div>
        <div class="col">
          <p class="text-center my-1 font-weight-bold text-order-normal">
            Gemiddelde Omlooptijd
          </p>
          <p class="text-center my-1 font-weight-bold order-font-size-normal">
            {{ (filteredResult.reduce((a, b) => a + (b.cycle_time || 0) ,0)  / filteredResult.filter((f) => f.cycle_time).length).toFixed(0) }} dagen
          </p>
        </div>
        <div class="col">
          <p class="text-center my-1 font-weight-bold text-order-normal">
            Gemiddelde service level
          </p>
          <p class="text-center my-1 font-weight-bold order-font-size-normal">
            {{ (filteredResult.reduce((a, b) => a + (b.service_level || 0) ,0)  / filteredResult.filter((f) => f.service_level).length).toFixed(0) }}%
          </p>
        </div>
        <div class="col">
          <p class="text-center my-1 font-weight-bold text-order-normal">
            Totale verkoop afgelopen week
          </p>
          <p class="text-center my-1 font-weight-bold text-order-success order-font-size-normal">
            € {{ filteredResult.reduce((a, b) => a + b.orders_7d * b.price,0).toFixed(0) }}
          </p>
        </div>
        <div class="col">
          <p class="text-center my-1 font-weight-bold text-order-normal">
            Gemiddelde verkoop per week
          </p>
          <p class="text-center my-1 font-weight-bold text-order-failed order-font-size-normal">
            € {{ (filteredResult.reduce((a, b) => a + b.orders_1y * b.price,0) / 52).toFixed(0) }}
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-12 col-md-7">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-default btn-outline btn-default-outline"
                  @click="setDate(new Date(Date.now() - (86400 * 1000 * 7)))"
                >
                  Week
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-outline btn-default-outline"
                  @click="setDate(new Date(Date.now() - (86400 * 1000 * 30)))"
                >
                  Maand
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-outline btn-default-outline"
                  @click="setDate(new Date(Date.now() - (86400 * 1000 * 365)))"
                >
                  Jaar
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-outline btn-default-outline"
                  @click="setDate(new Date(Date.now() - (86400 * 1000 * 14)), new Date(Date.now() - (86400 * 1000 * 7)))"
                >
                  Week-1
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-outline btn-default-outline"
                  @click="setDate(new Date(Date.now() - (86400 * 1000 * 60)), new Date(Date.now() - (86400 * 1000 * 30)))"
                >
                  Maand-1
                </button>
                <button
                  type="button"
                  class="btn btn-default btn-outline btn-default-outline"
                  @click="setDate(new Date(Date.now() - (86400 * 1000 * 730)), new Date(Date.now() - (86400 * 1000 * 365)))"
                >
                  Jaar-1
                </button>
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="d-flex justify-content-start">
                <div class="form-group d-flex align-items-center">
                  <label class="mb-0 mx-2"> Van </label>
                  <input type="date" placeholder="Van" class="form-control" style="border-radius: 0" v-model="dateFrom"/>
                </div>
                <div class="form-group d-flex align-items-center">
                  <label class="mb-0 mx-2"> Tot </label>
                  <input type="date" placeholder="Tot" class="form-control" style="border-radius: 0" v-model="dateTo"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-8">
          <div class="card p-2" style="height: 300px" v-if="selectedProduct">
            <p
              class="
                text-order-normal
                m-2
                font-weight-bold
              "
            >
              Voorraadwaarde
            </p>
            <highcharts :options="chartOptions" style="height: 250px" v-for="product in filteredResult" v-if="selectedProduct == product"></highcharts>

          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="card align-items-start p-3" style="height: 300px" v-if="selectedProduct">
            <p
              class="
                text-order-normal
                mb-2
                font-weight-bold
              "
            >
              Verkoopadvies
            </p>
            <p class="order-font-size-sm">Huidige voorraad: <b>{{ selectedProduct.currentStock }}</b></p>
            <p class="order-font-size-sm">
              Verwachte verkoop: <b>Max. {{selectedProduct.engine.baseSupplyNeeded}} producten per week</b>
            </p>
            <p class="order-font-size-sm">
              Advies voorrraad: <b>Min. {{selectedProduct.engine.baseSupplyPlusAdditionalPercentage}} producten</b>
            </p>
            <p class="order-font-size-sm">
              Nu te bestellen: <b>{{selectedProduct.engine.toOrder}} producten</b>
            </p>
            <button class="btn btn-secondary btn-secondary-two mt-4">
              Wijzigen
            </button>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <TableMainSearchField v-model="search" />
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refreshAdviceOrder"
        />
        <MultiplePageSizesSelection
          v-model="page_size"
          :available-values="availablePageSizeValues"
        />
      </div>

      <div class="mt-3 mb-1">
        <span class="mr-2"> Legenda </span>
        <span class="tag" :style="tagColors['brand']"> Productmerk </span>
        <span class="tag" :style="tagColors['category']">
          Productcategorie
        </span>
        <span class="tag" :style="tagColors['added']"> Toegevoegd sinds </span>
        <span class="tag" :style="tagColors['supplier']"> Leverancier </span>
      </div>
    </template>

    <template #cell-name="{ value, item }">
      <div class="my-2">
        <span>
          {{ value }}
        </span>
        <div class="d-flex mt-1">
          <span v-if="item.brand" class="tag" :style="tagColors['brand']">
            {{ item.brand }}
          </span>
          <span v-if="item.category" class="tag" :style="tagColors['category']">
            {{ item.category }}
          </span>
          <span v-if="item.date_added" class="tag" :style="tagColors['added']">
            {{ item.date_added | moment("from") }}
          </span>
          <span v-if="item.supplier" class="tag" :style="tagColors['supplier']">
            {{ item.supplier }}
          </span>
        </div>
      </div>
    </template>

    <template #cell-engine="{value}">
      <span class="d-flex align-items-center">
        <span class="dot mr-2" :style="{backgroundColor: value && value.color}"></span>
        {{ value.value }}
      </span>
    </template>

    <template #cell-stock_value="{value}">
      <span class="d-flex">
        € {{ value }}
      </span>
    </template>

    <template #cell-revenue_1y="{value}">
      <span class="d-flex">
         € {{ value }}
      </span>
    </template>
    <template #cell-revenue_custom="{value}">
      <span class="d-flex">
         € {{ value }}
      </span>
    </template>

    <template #cell-cycle_time="{value}">
      <span class="d-flex" v-if="value">
        {{ value }} dagen
      </span>
    </template>

    <template #cell-service_level="{value}">
      <span class="d-flex" >
        {{ value }}%
      </span>
    </template>

    <template #cell-orders_7d="{ item }">
      <span
        class="my-2"
        :class="{
          'text-success-order': item.pct_7d > 0,
          'text-danger-order': item.pct_7d < 0,
        }"
      >
        {{ item.orders_7d }}
        <div>
          {{ item.pct_7d_parsed }}
        </div>
      </span>
    </template>

    <template #cell-orders_1m="{ item }">
      <span
        class="my-2"
        :class="{
          'text-success-order': item.pct_1m > 0,
          'text-danger-order': item.pct_1m < 0,
        }"
      >
        {{ item.orders_1m }}
        <div>
          {{ item.pct_1m_parsed }}
        </div>
      </span>
    </template>

    <template #cell-orders_1y="{ item }">
      <span
        class="my-2"
        :class="{
          'text-success-order': item.pct_1y > 0,
          'text-danger-order': item.pct_1y < 0,
        }"
      >
        {{ item.orders_1y }}
        <div>
          {{ item.pct_1y_parsed }}
        </div>
      </span>
    </template>

    <template #cell-pct_1y="{ value }">
      <span> € {{ value }} </span>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder title="Er zijn geen adviesbestellingen">
        <svg
          width="18"
          height="18"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
        >
          <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)">
            <g>
              <path
                d="M4.5,12.5l-4,1,1-3v-9a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1Z"
                style="
                  fill: none;
                  stroke: currentColor;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                "
              ></path>
              <line
                x1="7.5"
                y1="3"
                x2="7.5"
                y2="6"
                style="
                  fill: none;
                  stroke: currentColor;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                "
              ></line>
              <circle
                cx="7.5"
                cy="9"
                r="0.5"
                style="
                  fill: none;
                  stroke: currentColor;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                "
              ></circle>
            </g>
          </g>
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>
import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import TableDatePickerField from '../components/Inputs/TableDatePickerField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'
import MultiplePageSizesSelection from '../layout/Table/MultiplePageSizesSelection.vue'

import table from "src/mixins/table"
import selectMultipleItems from "src/mixins/selectMultipleItems"
import TableCell from '../components/Table/TableCell.vue'
import { filters } from "src/utils/advice-order-filters"
import CheckboxOptions from "../layout/Table/DropdownCheckboxTableFilters/CheckboxOptions.vue";

import mom from "moment"

const BRANDS_TITLE = "Product Merk Filter"
const SUPPLIERS_TITLE = "Leverancier Filter"

export default {
  metaInfo: {
    title: "Order advies",
  },
  components: {
    TableHeader,
    TableMainSearchField,
    TableTemplate,
    TableDatePickerField,
    TableCell,
    RefreshBtn,
    EmptyStatePlaceholder,
    MultiplePageSizesSelection
},
  mixins: [
    selectMultipleItems,
    tableFieldOptions,
    table({
      pageReference: 'advice-orders',

      manualPagination: true,
      disableAlphabeticalSort: true,
      disablePageChangeRefetch: true,

      columnTranslationMaps: {
        "SKU": "reference",
        "Naam": "name",
        "Voorraad": "currentStock",
        "7d": "orders_7d",
        "1M": "orders_1m",
        "1Y": "orders_1y",
        "Omzet 1Y": "revenue_1y",
        "Voorraadwaarde": "stock_value",
        "Service Level": "service_level",
        "Engine advies": "engine",
        "Omlooptijd": "cycle_time",
        "Invoer": "orders_custom",
        "Omzet invoer": "revenue_custom"
      },
      selectCustomization: (vm, filters) => vm.filters = filters,

      defaultColumns: [
        "SKU", "Naam", "Voorraad", "7d", "1M", "1Y", "Omzet 1Y", "Engine advies"
      ],
      defaultColumnSizes: {
        reference: 50,
        name: 300,
        currentStock: 80,
        orders_7d: 80,
        orders_1m: 80,
        orders_1y: 80,
        revenue_1y: 100
      },
      columnConfigurationId: "advice-order",

      params: {
        search: ""
      },
      page_size: 100,
      toISOFields: ["initialDate", "finalDate"],

      parseParamsBeforeSending: () => ({}),

      route: "/drop/products",
    }),
  ],
  data() {
    return {
      productSettings: {},

      productOrderOverride: {},
      productSettingsSaved: false,
      productOrderOverrideSaved: false,
      filters: [],

      settings: {},
      form: {
        productSettings: {},
      },
      customLoading: false,
      selectedProduct: null,
      dateFrom: undefined,
      dateTo: new Date().toISOString().split('T')[0],
    }
  },
  created() {
    this.loadSettings()
    const filters = localStorage.getItem("advice-order-filters")
    if (filters) this.filters = JSON.parse(filters)

    const brands = Array.from(this.availableBrands)
    const suppliers = Array.from(this.availableSuppliers)

    const brandsFilters = this.filters.filter(filter => filter.title === BRANDS_TITLE).map(filter => filter.value)
    const suppliersFilters = this.filters.filter(filter => filter.title === SUPPLIERS_TITLE).map(filter => filter.value)

    brandsFilters.forEach(filter => {
      if (!brands.includes(filter.value)) {
        this.filters.splice(this.filters.findIndex(item => filter.value === item.value), 1)
      }
    })
    suppliersFilters.forEach(filter => {
      if (!suppliers.includes(filter.value)) {
        this.filters.splice(this.filters.findIndex(item => filter.value === item.value), 1)
      }
    })
  },
  methods: {
    getSelectedExtraSections() {
      return this.filters
    },

    async updateProductOrder() {
      this.$handlePromise(async () => {
        await this.axios.post('/drop/products/order', this.productOrderOverride[this.selectedProduct.id])
        this.productOrderOverrideSaved = this.selectedProduct.id

        this.loadSettings(true, false)
        this.updateFetchCache()
      })
    },
    async updateProductSettings() {
      this.$handlePromise(async () => {
        this.productSettings[this.selectedProduct.id] = this.form.productSettings
        await this.axios.post('/drop/products/settings', this.productSettings[this.selectedProduct.id])
        this.productSettingsSaved = this.selectedProduct.id

        this.loadSettings(true, false)
        this.updateFetchCache()
      })
    },

    selectRow(item) {
      this.selectedProduct = item

      this.form.productSettings = Object.assign({}, this.productSettings[this.selectedProduct.id])
    },
    async loadSettings(fresh, showLoading = true) {
      if (showLoading) this.customLoading = true

      const [{data: productSettings}, {data: graphSettings}, {data: ordersData}] = await Promise.all([
        this.$store.dispatch("cachedGet", {
          endpoint: "/drop/products/settings",
          fresh,
        }),
        this.$store.dispatch("cachedGet", {
          endpoint: "/drop/settings",
          fresh,
        }),
        this.$store.dispatch("cachedGet", {
          endpoint: "/drop/products/order",
          fresh,
        }),
      ])

      if (!showLoading) return;

      this.settings = graphSettings.reduce((obj, curr) => ({
        ...obj,
        [curr.topic]: curr
      }), {})
      this.productSettings = productSettings.reduce((obj, curr) => ({
        ...obj,
        [curr.product_id]: curr,
      }), {});
      this.productOrderOverride = ordersData.reduce((obj, curr) => ({
        ...obj,
        [curr.product_id]: curr,
      }), {})

      this.customLoading = false
    },
    refreshAdviceOrder() {
      this.loadSettings(true)
      this.get(undefined, true)
    },
    showCustomerInformation(item) {
      this.$pushModal({
        modal: "CustomerInformation",
        toBind: {
          item,
        },
      })
    },

    settingsToPlotBands() {
      let plotBands = []
      let settingsToTake = ['y2019_ramadan', 'y2019_eid_fitr', 'y2019_eid_adha', 'y2019_december', 'y2019_other',
        'y2020_ramadan', 'y2020_eid_fitr', 'y2020_eid_adha', 'y2020_december', 'y2020_other',
        'y2021_ramadan', 'y2021_eid_fitr', 'y2021_eid_adha', 'y2021_december', 'y2021_other',
        'y2022_ramadan', 'y2022_eid_fitr', 'y2022_eid_adha', 'y2022_december', 'y2022_other']

      const settings = this.settings
      for (const settingToTake of settingsToTake) {
        if (!settings[settingToTake].value) {
          continue;
        }
        let year = settingToTake.split('y')[1].split('_')[0];
        let weekStart = (-.5 + parseInt(settings[settingToTake].value.trim())) + ''
        let weekEnd =   (.5 + parseInt(settings[settingToTake].value.trim())) + ''

        if (settings[settingToTake].value.indexOf(',') !== -1) {
          weekStart = settings[settingToTake].value.split(',')[0].trim()
          weekEnd = settings[settingToTake].value.split(',').slice(-1)[0].trim()
        }

        plotBands.push({
          color: '#FED8B1', // Color value
          from: mom(year + ' ' + weekStart, 'YYYY w').toDate().getTime(), // Start of the plot band
          to: mom(year + ' ' + weekEnd, 'YYYY w').toDate().getTime(), // End of the plot band
        });
      }

      return plotBands
    },

    calculateCustomDateRangeFields(dateFrom, dateTo) {
      let dateFromYearWeek = mom(new Date(dateFrom)).format('YYYY w')
      let dateToYearWeek = mom(new Date(dateTo)).format('YYYY w')

      if (new Date(dateTo) > new Date(dateFrom)) {
        for (const product of this.filteredResult) {
          const orderIndex = Object.keys(product.orders);
          let start = orderIndex.indexOf(dateFromYearWeek)
          let end = orderIndex.indexOf(dateToYearWeek)

          product.orders_custom = 0;
          for (let i = start; i <= end; i++) {
            product.orders_custom += product.orders[orderIndex[i]] || 0;
          }
          product.revenue_custom = (product.orders_custom * product.price).toFixed(2)
        }
      }
    },
    setDate(from, to) {
      this.dateFrom = mom(from).format('YYYY-MM-DD')
      if (!to) {
        this.dateTo = mom(new Date()).format('YYYY-MM-DD')
      } else {
        this.dateTo = mom(to).format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    availableBrands() {
      return new Set(this.computedResult.map(prod => prod.brand).filter(brand => brand))
    },
    availableSuppliers() {
      return new Set(this.computedResult.map(prod => prod.supplier).filter(supplier => supplier))
    },
    availablePageSizeValues() {
      if (this.filteredResult.length) {
        return [100, this.filteredResult.length];
      }
      return [10]
    },
    expandCustomizations() {
      return [
        {
          title: "Filters",
          values: Object.keys(filters),
        },
        {
          title: BRANDS_TITLE,
          values: this.availableBrands,
        },
        {
          title: SUPPLIERS_TITLE,
          values: this.availableSuppliers,
        },
      ]
    },
    exportEndpointParams() {
      return {
        products: this.filteredResult.map(item => item.sku)
      }
    },
    computedResult() {
      const settings = this.productSettings

      const parseNumber = number => {
        if (!number) return "N/A"

        const parsed = parseFloat((number + "").replace(",", ".")).toFixed(0)
        return isNaN(parsed) ? "N/A" : `${parsed}%`
      }

      return this.result.map ? this.result.map(item => ({
        ...item,
        supplier: settings[item.id] ? settings[item.id].supplier : null,

        pct_1m_parsed: parseNumber(item.pct_1m),
        pct_1y_parsed: parseNumber(item.pct_1y),
        pct_7d_parsed: parseNumber(item.pct_7d),
        revenue_1y: (item.orders_1y * item.price).toFixed(2),
        stock_value: (item.currentStock * item.price).toFixed(2),
        service_level: Math.round((Object.values(item.stockCount).filter((v) => v > item.engine.baseSupplyNeeded).length / Object.keys(item.stockCount).length) * 100),
        cycle_time: Math.round(item.currentStock / (item.currentStock * item.price / 2) * 365)
      })) : []
    },
    filteredItems() {
      const search = this.search.toLowerCase()
      let filtered = this.computedResult.filter(item => {
        return item.name.toLowerCase().includes(search) ||
          item.id.toLowerCase().includes(search)
      })

      if (this.filters.length) {
        // Do not delete these references! They are used for giving a hint to VueJs reactivity system. If you remove them, then this computed property won't be reactive anymore.
        this.productOrderOverride
        // --------

        const mainFilters = this.filters.filter(filter => filter.title === "Filters") || []

        filtered = mainFilters.reduce((filtered, filter) => {
          return filtered.filter(prod => {
            return filters[filter.value](prod, this)
          })
        }, filtered)

        const brands = this.filters.filter(filter => filter.title === BRANDS_TITLE).map(filter => filter.value)
        const suppliers = this.filters.filter(filter => filter.title === SUPPLIERS_TITLE).map(filter => filter.value)

        if (brands.length) filtered = filtered.filter(prod => brands.includes(prod.brand))
        if (suppliers.length) filtered = filtered.filter(prod => suppliers.includes(prod.supplier))

        return filtered
      }
      return filtered
    },
    /// This is used on table.js
    filteredResult() {
      const filtered = this.filteredItems.slice()
      const property = this.sort
      const order = this.order

      property && filtered.sort((a, b) => {
        switch (property) {
          case "name": {
            return order === "asc"
              ? a[property].localeCompare(b[property])
              : b[property].localeCompare(a[property])
          }
          case "engine": {
            return this.sortNumber(a.engine.value, b.engine.value, true, order)
          }

          default: {
            return this.sortNumber(a[property], b[property], false, order)
          }
        }
      })

      return filtered
    },
    // --------
    loadedSettingsAndProducts() {
      return !this.loadingSettings && !this.isLoadingTableResult
    },
    tagColors() {
      return {
        brand: {backgroundColor: "#6c757d"},
        category: {backgroundColor: "#0081C9"},
        added: {backgroundColor: "#F48F32"},
        supplier: {backgroundColor: "#397678"},
      }
    },
    chartOptions() {
      var self = this

      if (self.selectedProduct) {

        return {
          title: {
            text: "",
          },
          chart: {
            type: 'spline',
            zoomType: 'x',
            backgroundColor: "rgba(0,0,0,0)",
            height: 255
          },
          xAxis: {
            type: 'datetime',
            labels: {
              enabled: true,
              rotation: 45,
              align: 'left'
            },
            plotBands: this.settingsToPlotBands(),
            min: this.dateFrom ? new Date(this.dateFrom).getTime() : new Date(self.selectedProduct.date_added).getTime(),
            max: this.dateTo ? new Date(this.dateTo).getTime() : new Date().getTime()
          },
          yAxis: {
            title: {
              text: "",
            },
            min: 0
          },
          plotOptions: {
            spline: {
              lineWidth: 4,
              states: {
                hover: {
                  lineWidth: 5
                }
              },
              pointInterval: 1000 * 60 * 60 * 24 * 7, // one week
              pointStart: new Date(self.selectedProduct.date_added).getTime()
            }
          },
          series: [{
            name: 'verkocht',
            // for each order (per week),
            data: Object.entries(self.selectedProduct.orders).map((h) => {
              return [h[0], h[1]]
            }),
            color: '#16D379'
          },
            {
              name: 'voorraad',
              // for each order (per week),
              data: Object.entries(self.selectedProduct.stockCount).map((h) => {
                return [h[0], h[1]]
              }),
              color: '#C7314A'
            }]
        }
      }
    },

    dangerRows() {
      const productSettings = this.productSettings
      return this.filteredResult.filter(({ id }) => productSettings[id] && productSettings[id].stopped).map(item => item.id)
    },
  },
  watch: {
    filters(filters) {
      localStorage.setItem("advice-order-filters", JSON.stringify(filters))
    },
    dangerRows(dangeredRows) {
      requestAnimationFrame(() => {
        this.filteredResult.forEach(({ id, name }) => {
          if (dangeredRows.includes(id)) {
            const item = document.querySelector(`#table-row-${id}`)
            item && item.classList.add("table-danger")
          } else {
            const item = document.querySelector(`#table-row-${id}`)
            item && item.classList.contains("table-danger") && item.classList.remove("table-danger")
          }
        })
      })
    },
    selectedProduct({id}, oldProduct) {
      if (id) {
        document.querySelector(`#table-row-${id}`).classList.add("selected-row")
      }
      if (oldProduct && oldProduct.id) {
        const oldRow = document.querySelector(`#table-row-${oldProduct.id}`)
        if (oldRow) oldRow.classList.remove("selected-row")
      }
    },
    tableResult(val) {
      this.$emit("table-items", val)
    },
    loadedSettingsAndProducts(val) {
      if (val) {
        this.result.forEach(({id}) => {
          if (!this.settings[id]) {
            this.settings[id] = {product_id: id}
            this.productOrderOverride[id] = {product_id: id}
          }
        })
      }
    },
    dateFrom(newDate, oldDate) {
      if (!newDate) {
        return;
      }
      if (newDate !== oldDate) {
        this.calculateCustomDateRangeFields(newDate, this.dateTo)
      }
    },
    dateTo(newDate, oldDate) {
      if (!newDate) {
        return;
      }
      if (newDate !== oldDate) {
        this.calculateCustomDateRangeFields(this.dateFrom, newDate)
      }
    }
  },
}
</script>

<style>
.selected-row {
  border-top: 1px solid var(--mint-green) !important;
}
.selected-row + tr {
  border-top: 1px solid var(--mint-green) !important;
}
.selected-row td {
  background-color: rgba(50, 202, 210, .1);
}
.table-danger {
  border-top: 1px solid #ed969e !important;
}
.table-danger + tr {
  border-top: 1px solid #ed969e !important;
}
.table-danger td {
  background-color: #f5c6cb !important;
}
.table-danger:hover td {
  background-color: #ed9ba4 !important;
}
</style>

<style scoped>
#klantoverzicht::v-deep .content-wrapper > .content-wrapper {
  flex-direction: column-reverse;
}
.graph-wrapper {
  width: 100% !important;
  min-width: unset;
  max-width: unset;
}

.empty-placeholder-wrapper {
  margin: 70px 0;
}

@media (min-width: 920px) {
  #klantoverzicht::v-deep .content-wrapper > .content-wrapper {
    flex-direction: row;
  }

  .graph-wrapper {
    min-width: 500px !important;
    width: unset;
    max-width: 500px;
  }
}

@media (min-width: 1300px) {

  .graph-wrapper {
    min-width: 700px !important;
    width: unset;
    max-width: 700px;
  }
}

h4 {
  font-weight: 500 !important;
  margin: 0px;
  margin-bottom: 4px;
}

.graph-details {
  font-weight: 300 !important;
  font-size: 18px;
}

b {
  font-weight: 600 !important;
}

.section {
  margin: 14px 0;
  border-top: 1px solid rgba(0,0,0,.1);
}

p {
  margin: 0px;
}

.tag {
  font-size: 10px !important;
  border-radius: 2px;
  padding: 3px 5px;
  color: white;
  font-weight: 600;
}

.tag + .tag {
  margin-left: 4px;
}

.dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 1000px;
}

.name-wrapper {
  color: currentColor;
}

.name-wrapper:hover {
  text-decoration: underline;
}

.date-picker-btn {
  background-color: green !important;
}

.grid-filters {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}

.chart {
  border-left: 1px solid #EFEFF0;
}

.chart, .chart > div {
  height: 100%;
}

@media (max-width: 1000px) {
  .grid-filters {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .chart {
    margin: 0 !important;
    margin-top: 3px !important;
  }
}

@media (max-width: 800px) {
  .grid-filters {
    grid-template-columns: 1fr;
  }
}

</style>

<style>
.advice-order-filters .date-picker-button {
  padding: 9.5px !important;
}

.advice-order-filters .date-picker-button {
  padding: 9.5px !important;
}

.text-order-success {
  color: #16d379;
}

.text-order-failed {
  color: #c7314a;
}

.text-order-normal {
  color: #6d6e71;
  font-size: 17px;
}

.order-font-size-normal {
  font-size: 16px;
  padding: 5px 0;
}

.order-font-size-sm {
  font-size: 14px;
  padding: 5px 0;
}

.product-show-all-btn {
  background-color: white !important;
  border-radius: 2px;
}

.btn-secondary-two {
  background-color: #a7a9ab;
  padding: 10px !important;
}

.btn-default-outline {
  background: #fff;
  border: 0.5px solid #d1d3d4;
  padding: 10px 13px;
}

.text-success-order {
  color: #16D379;
}

.text-danger-order {
  color: #C7314A;
}
</style>
